/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderDot: {
  name: 'folder-dot';
  data: string;
} = {
  name: 'folder-dot',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M1 13V3a1 1 0 0 1 1-1h3.586a1 1 0 0 1 .707.293l1.414 1.414A1 1 0 0 0 8.414 4H14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><circle cx="5" cy="8" r="1" fill="currentColor"/><circle cx="5" cy="11" r="1" fill="currentColor"/><circle cx="8" cy="8" r="1" fill="currentColor"/><circle cx="8" cy="11" r="1" fill="currentColor"/><circle cx="11" cy="8" r="1" fill="currentColor"/><circle cx="11" cy="11" r="1" fill="currentColor"/></svg>`,
};
